/**************************************************
 * Nombre:       TextoTitulo
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {NEGRITA} from "../../../../Constantes";
import {theme} from "../../../../Tema";


const TextoTitulo = ({texto, titulo}) => {

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                <Typography
                    sx={{color: theme.palette.primary.main, fontWeight: 600}}
                >{texto}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{justifyContent: 'center'}}>
                <Typography
                    sx={{fontFamily: NEGRITA, fontSize: 66, lineHeight: 1.1, textAlign: 'center'}}>{titulo}</Typography>
            </Grid>


        </Grid>
    )

}
export default TextoTitulo